import { gcpExportFilesToZip } from "@/app/valuationFeedback/api";
import { message } from "@/basa/utils/message.js";

export const loadingParams = { isShowLoading: true };

export function showErrorMessage(msg) {
  return message.error(msg);
}

// 附件批量导出
export async function exportFiles(res) {
  let tempStorage = res;

  const requestData = {
    // downloadUrl: tempStorage.ossUrl,
    downLoadFileBOList: tempStorage.downLoadFileBOList
  };
  tempStorage = await gcpExportFilesToZip(requestData);
  // 设置文件名
  const disposition = tempStorage.headers["content-disposition"];
  let fileName = decodeURIComponent(disposition.split("=utf-8''")[1], "UTF-8");

  // 如果本来是文件流的话则直接导出
  const url = URL.createObjectURL(
    new Blob([tempStorage.data], { type: tempStorage.data.type })
  );
  // 判断有该方法即为IE浏览器  msSaveBlob
  if (window.navigator.msSaveOrOpenBlob) {
    const blobUrl = new Blob([tempStorage.data], {
      type: tempStorage.data.type
    });
    try {
      window.navigator.msSaveOrOpenBlob(blobUrl, fileName);
    } catch (e) {
      console.log(e);
    }
  } else {
    if (!disposition) return showErrorMessage("响应头参数错误，请重试！");
    // if (!disposition) return showErrorMessage(window.$t('contractManagementEntry.listPage.xiangyingtoucanshucuowuqingchongshi'));

    let openUrl = document.createElement("a");
    openUrl.style.display = "none";
    openUrl.download = decodeURIComponent(
      disposition.split("=utf-8''")[1],
      "UTF-8"
    );
    openUrl.href = url;
    openUrl.setAttribute("rel", "noopener noreferrer");
    document.body.appendChild(openUrl);
    openUrl.click();
    document.body.removeChild(openUrl);
    URL.revokeObjectURL(url); // 释放内存
  }
}
